import React from 'react';

import { CalendlyBubble } from 'components/SmartAssistantComponents/CalendlyBubble';
import { LeadFormBubble } from 'components/SmartAssistantComponents/LeadFormBubble';
import { MessageBubbleProps } from 'components/SmartAssistantComponents/MessageBubble';
import { AnimatePresence } from 'framer-motion';
import { ToolVisibilityOverrides, useToolVisibility } from 'hooks/use-tool-visibility';
import { ViewMode } from 'shared/enums/ViewMode';
import { ChatMessage } from 'shared/interfaces/ChatMessage';
import { SmartAssistantVisualConfig } from 'shared/interfaces/SmartAssistant';
import { ToolConfig, ToolKind } from 'shared/interfaces/tools/Tool';

interface ChatStaticToolsViewProps extends MessageBubbleProps {
  smartAssistantVisualConfig: SmartAssistantVisualConfig;
  smartAssistantId: string;
  toolConfigs: ToolConfig[];
  viewMode: ViewMode;
  conversationLength: number;
  addNewMessageToConversation?: (newMessage: ChatMessage) => void;
  visibilityOverrides?: ToolVisibilityOverrides;
}

export function ChatStaticToolsView({
  smartAssistantVisualConfig,
  smartAssistantId,
  toolConfigs,
  viewMode,
  conversationLength,
  addNewMessageToConversation,
  visibilityOverrides,
  ...messageBubbleProps
}: ChatStaticToolsViewProps) {
  const { visibleToolKinds } = useToolVisibility({
    toolConfigs,
    smartAssistantId,
    conversationLength,
    visibilityOverrides
  });

  return (
    <AnimatePresence>
      {visibleToolKinds.includes(ToolKind.COLLECT_LEAD_INFO) && (
        <LeadFormBubble
          key={ToolKind.COLLECT_LEAD_INFO}
          smartAssistantVisualConfig={smartAssistantVisualConfig}
          smartAssistantId={smartAssistantId}
          toolConfigs={toolConfigs}
          viewMode={viewMode}
          addNewMessageToConversation={addNewMessageToConversation}
          {...messageBubbleProps}
        />
      )}

      {visibleToolKinds.includes(ToolKind.CALENDLY) && (
        <CalendlyBubble
          key={ToolKind.CALENDLY}
          smartAssistantId={smartAssistantId}
          toolConfigs={toolConfigs}
          smartAssistantVisualConfig={smartAssistantVisualConfig}
          conversationLength={conversationLength}
          {...messageBubbleProps}
        />
      )}
    </AnimatePresence>
  );
}
